import { render } from "./CalendarNavigator.vue?vue&type=template&id=2b6a912e"
import script from "./CalendarNavigator.vue?vue&type=script&lang=js"
export * from "./CalendarNavigator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__